
import text from '../../../../../text';

const TOURS = {
  TOUR_2D_MAP: 'TOUR_2D_MAP',
  TOUR_FILE_MANAGER: 'TOUR_FILE_MANAGER',
  TOUR_3D_VIEWER: 'TOUR_3D_VIEWER',
};

const MODAL_TOUR_NAMES = {
  TOUR_2D_MAP: '2d_map_tour',
  TOUR_FILE_MANAGER: 'file_manager_tour',
  TOUR_3D_VIEWER: '3d_viewer_tour',
};

const TOUR_MODAL_START_CONFIG = {
  [TOURS.TOUR_2D_MAP]: {
    gif: '/public/img/2D-map.gif',
    title: text('tourModal2dTitle'),
    description: text('tourModal2dDescription'),
    done: text('tourModal2dDone'),
    requiresMap: true,
  },
  [TOURS.TOUR_FILE_MANAGER]: {
    gif: '/public/img/filemanager.gif',
    title: text('tourModalFilemanagerTitle'),
    description: text('tourModalFilemanagerDescription'),
    done: text('tourModalFilemanagerDone'),
    requiresMap: false,
  },
  [TOURS.TOUR_3D_VIEWER]: {
    gif: '/public/img/3D_Viewer.gif',
    title: text('tourModal3dViewerTitle'),
    description: text('tourModal3dViewerDescription'),
    done: text('tourModal3dViewerDone'),
    requiresMap: false,
  },
};

const hightlightedAreaStyling = (
  base: React.CSSProperties,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: Record<string, any> // no appropriate type from Reactour
) => {
  const { x = 0, y = 0, width = 0, height = 0, rx = 3 } = state || {};
  return {
    ...base,
    display: 'block',
    stroke: '#f00',
    strokeWidth: 3,
    width: width + 6,
    height: height + 6,
    rx,
    x: x - 3,
    y: y - 3,
    pointerEvents: 'none' as const,
  };
};

const popoverCustomDefaultStyling = (props: React.CSSProperties) => ({
  ...props,
  borderRadius: 6,
  padding: 0,
});

export {
  TOURS,
  TOUR_MODAL_START_CONFIG,
  hightlightedAreaStyling,
  popoverCustomDefaultStyling,
  MODAL_TOUR_NAMES,
};
